import { axiosObject } from "../config";

export function getFileByOwnerIdentifier(owner_identifier: string) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/files/_read";
    let payload = {
      filterBy: [
        {
          attribute: "owner_identifier",
          op: "eq",
          value: owner_identifier,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
export function getFileByUuid(uuid: string) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/files/_read";
    let payload = {
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
